import './App.css';
import React from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';

import useUserStore from './UserStore';
import { Navigate } from 'react-router-dom';

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { SharedStateProvider } from './SharedStateContext';

import ProtectedRoute from './ProtectedRoute';
import LoginForm from './LoginForm';
import ProfileForm from './ProfileForm';
import MetroIconLauncher from './MetroIconLauncher';
import BackstageSideMenu from './BackstageSideMenu';
import CustomerTable from './CustomerTable';
import PackageForm from './PackageForm';
import InvoiceTable from './InvoiceTable';
import InvoiceForm from './InvoiceForm';
import InvoicePayForm from './InvoicePayForm';
import InvoicePaymentResultForm from './InvoicePaymentResultForm';
import OrderTable from './OrderTable';
import OrderEntryForm from './OrderEntryForm';
import OrderViewForm from './OrderViewForm';
import LogTable from './LogTable';
import Dashboard from './Dashboard';
import SpotTable from './SpotTable';
import CustomerAddForm from './CustomerAddForm';
import CustomerViewForm from './CustomerViewForm';
import ManualUpload from './ManualUpload';
import AdminForm from './AdminForm';
import Billboard from './Billboard';
import Stations from './Stations';
import StationAddForm from './StationAddForm';
import useActivityTracker from './UserActivityTracker';
import UserSessionWarning from './UserSessionWarning';
import SpotAddForm from './SpotAddForm';
// import NotificationForm from './NotificationForm';
// import MusicTabs from './logs/MusicTabs';

function App() {
  const isAuthorized = useUserStore((state) => state.isAuthorized);

  // track user activity for session timeout
  useActivityTracker();

  function LogoutHandler() {
    const logout = useUserStore((state) => state.logout);
    
    React.useEffect(() => {
      logout();
    }, [logout]);

    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="text-lg">Logging out...</div>
        </div>
      </div>
    );
  }


  return (     
    <div className="bg-white">
      {isAuthorized && <BackstageSideMenu className="z-10"/>}
 
      <UserSessionWarning />

      <GoogleOAuthProvider clientId="732971614822-mv0cgcqds7a03rvv937cmppg467mib50.apps.googleusercontent.com">
        <BrowserRouter>
          <SharedStateProvider>
            <Routes> 
              {/* Public Routes */}
              <Route path="/login" element={<LoginForm />} />
              <Route path="invoicepay/:invoiceId" element={<InvoicePayForm />} />
              <Route path="payment/success" element={<InvoicePaymentResultForm />} />
              <Route path="payment/next" element={<InvoicePaymentResultForm />} />
              
              {/* Protected Routes */}
              <Route path="/billboard" element={
                <ProtectedRoute requiredFunctionalArea="Billboard">
                  <Billboard />
                </ProtectedRoute>
              } />
              <Route path="/billboard/stations" element={
                <ProtectedRoute requiredFunctionalArea="Billboard">
                  <Stations />
                </ProtectedRoute>
              } />
              <Route path="/" element={
                <ProtectedRoute requiredFunctionalArea="Dashboard">
                  <Dashboard />
                </ProtectedRoute>
              } />
              <Route path="profile" element={
                <ProtectedRoute requiredFunctionalArea="Profile">
                  <ProfileForm />
                </ProtectedRoute>
              } />
              <Route path="metro" element={
                <ProtectedRoute requiredFunctionalArea="Dashboard">
                  <MetroIconLauncher />
                </ProtectedRoute>
              } />
              <Route path="customers" element={
                <ProtectedRoute requiredFunctionalArea="Customers">
                  <CustomerTable />
                </ProtectedRoute>
              } />
              <Route path="customeradd" element={
                <ProtectedRoute requiredFunctionalArea="Customers">
                  <CustomerAddForm />
                </ProtectedRoute>
              } />
              <Route path="/customeredit/:customerId" element={
                <ProtectedRoute requiredFunctionalArea="Customers">
                  <CustomerAddForm />
                </ProtectedRoute>
              } />
              <Route path="/customerview/:customerId" element={
                <ProtectedRoute requiredFunctionalArea="Customers">
                  <CustomerViewForm />
                </ProtectedRoute>
              } />
              <Route path="packages" element={
                <ProtectedRoute requiredFunctionalArea="Packages">
                  <PackageForm />
                </ProtectedRoute>
              } />
              <Route path="orders" element={
                <ProtectedRoute requiredFunctionalArea="Orders">
                  <OrderTable />
                </ProtectedRoute>
              } />
              <Route path="orderentry/:packageId" element={
                <ProtectedRoute requiredFunctionalArea="Orders">
                  <OrderEntryForm />
                </ProtectedRoute>
              } />
              <Route path="orderentry/edit/:orderId" element={
                <ProtectedRoute requiredFunctionalArea="Orders">
                  <OrderEntryForm />
                </ProtectedRoute>
              } />
              <Route path="orderentry/clone" element={
                <ProtectedRoute requiredFunctionalArea="Orders">
                  <OrderEntryForm />
                </ProtectedRoute>
              } />  
              <Route path="order/view/:orderId" element={
                <ProtectedRoute requiredFunctionalArea="Orders">
                  <OrderViewForm />
                </ProtectedRoute>
              } />
              <Route path="invoices" element={
                <ProtectedRoute requiredFunctionalArea="Invoices">
                  <InvoiceTable />
                </ProtectedRoute>
              } />
              <Route path="invoiceadd" element={
                <ProtectedRoute requiredFunctionalArea="Invoices">
                  <InvoiceForm />
                </ProtectedRoute>
              } />
              <Route path="invoiceedit/:invoiceId" element={
                <ProtectedRoute requiredFunctionalArea="Invoices">
                  <InvoiceForm />
                </ProtectedRoute>
              } />
              <Route path="invoiceview/:invoiceId" element={
                <ProtectedRoute requiredFunctionalArea="Invoices">
                  <InvoiceForm />
                </ProtectedRoute>
              } />
              <Route path="logs" element={
                <ProtectedRoute requiredFunctionalArea="Logs">
                  <LogTable />
                </ProtectedRoute>
              } />
              <Route path="spots" element={
                <ProtectedRoute requiredFunctionalArea="Spots">
                  <SpotTable />
                </ProtectedRoute>
              } />
              <Route path="spotadd" element={
                <ProtectedRoute requiredFunctionalArea="Spots">
                  <SpotAddForm />
                </ProtectedRoute>
              } />
              <Route path="spotedit/:spotId" element={
                <ProtectedRoute requiredFunctionalArea="Spots">
                  <SpotAddForm />
                </ProtectedRoute>
              } />
              <Route path="spotview/:spotId" element={
                <ProtectedRoute requiredFunctionalArea="Spots">
                  <SpotAddForm />
                </ProtectedRoute>
              } />              <Route path="admin" element={
                <ProtectedRoute requiredFunctionalArea="Admin">
                  <AdminForm />
                </ProtectedRoute>
              } />
              <Route path="stationadd" element={
                <ProtectedRoute requiredFunctionalArea="Billboard">
                  <StationAddForm />
                </ProtectedRoute>
              } />
              <Route path="upload" element={
                <ProtectedRoute requiredFunctionalArea="Manual Upload">
                  <ManualUpload />
                </ProtectedRoute>
              } />
              <Route path="logout" element={<LogoutHandler />} />

              {/* Catch all route - redirect to login if not authorized, dashboard if authorized */}
              <Route path="*" element={
                isAuthorized ? <Navigate to="/" replace /> : <Navigate to="/login" replace />
              } />

              {/* <Route path="admin" element={<MusicTabs />} />
              <Route path="notifications" element={<NotificationForm />} /> */}
            </Routes>
          </SharedStateProvider>
        </BrowserRouter>
      </GoogleOAuthProvider>
    </div>
  );
  }

  //    } else {
  //   return (
  //     <div className="bg-white">
  //     <GoogleOAuthProvider clientId="732971614822-mv0cgcqds7a03rvv937cmppg467mib50.apps.googleusercontent.com">
  //       <BrowserRouter>
  //         <Routes>                
  //           <Route path="/" element={<LoginForm/>} />
  //         </Routes>
  //       </BrowserRouter>
  //     </GoogleOAuthProvider>
  //     </div>
  //   );
  // }

export default App;